import { Injectable } from '@angular/core';

//Import users

//Import Obsevable to make service asynchronous
import { Observable } from 'rxjs/Observable';
import { Subject } from "rxjs/Subject";
import { forkJoin } from "rxjs/observable/forkJoin";
import { of } from 'rxjs/observable/of';

//Import for messages
import { MessageService } from 'services/message.service'
import { Http, Headers, RequestOptions } from '@angular/http';

import { AuthService } from 'services/auth.service';

import * as _ from 'underscore';
import { PagerService } from 'services/index';
import { GlobalService } from 'services/global.service'
import { Pager } from '../../../../pager';

@Injectable()
export class StudentDetailService {
  domain = this.authService.domain;

  questionsAll : any[];
  questions = new Subject<any[]>();
  courseAndProject = new Subject<any>();
  student = new Subject<any>();

  pagerProcess;
  pager = new Subject<Pager>();
  sortingConsultant='question.no';//API側で非同期処理で順番入れ替わることあるためこっちでソートする（API側を順番に処理するように変更してソート回数を減らしたほうがいいかもしれない）
  Acs = true;
  totalItems = this.globalService.totalItems;
  processing: boolean;
  isDataAvailable: boolean;

  questions$ = this.questions.asObservable();
  pager$ = this.pager.asObservable();
  courseProject$ = this.courseAndProject.asObservable();
  student$ = this.student.asObservable();
  
  constructor(
  	private messageService: MessageService,
  	private http: Http,
    private authService: AuthService,
    private pagerService:　PagerService,
    private globalService : GlobalService
  ) {
  }
  //---------------------------------- Getting API data with subscribe ---------------------------------------------------
  // getting the question of answer by student
  // Type : Get
  // Parse : student_id, course_id    
  getQuestionAPI(student_id, course_id) {
    const url = this.domain + 'answer_history/student/course/' + student_id + "/" + course_id;

    return this.http.get(url , this.authService.options).map(res => res.json());    
  }

  
  // getting answered data of the question
  // Type : Get
  // Parse : student_id, course_id  , question ID 
  apiExplanationProblem(student_id, course_id, question_id) {
    const url = this.domain + 'answer_history/student/course/question/' + student_id + '/' + course_id + '/' + question_id;

    return this.http.get(url, this.authService.options).map(res => res.json());
  }

  // getting student data by student id
  // Type : Get
  // Parse : student_id
  apiStudent(student_id) {
    const url = this.domain + 'student/' + student_id;

    return this.http.get(url, this.authService.options).map(res => res.json());
  }

  // getting course data by course code
  // Type : Get
  // Parse : course_code
  apiCourse(course_code) {
    const url = this.domain + 'course/' + course_code;

    return this.http.get(url, this.authService.options).map(res => res.json());
  }

  // ---------------------------------- Process subcribe API data --------------------------------------------------------
  // Process Login API data with call back 
  getQuestion(student_id, course_id) {
    forkJoin([
      this.getQuestionAPI(student_id, course_id),
      this.apiCourse(course_id),
      this.apiStudent(student_id),
    ]).subscribe( data => {
      
      this.questionsAll = data[0];
      this.setPage(1);

      if (data[1]) this.courseAndProject.next(data[1]);

      if (data[2]) this.student.next(data[2]);
    },
    err => {
      this._errorHandler(err);
    });
  }

  getExplanationProblem(student_id, course_id, question_id) {
    return new Promise<any>((resolve, reject) => {
      this.apiExplanationProblem(student_id, course_id, question_id).subscribe( data => {
        resolve(data);
      },
      err => {
        console.log(err);
        reject(err);
      });
    });
  }

  // function for handle error 
  // example: response status 500
  // *note: now only handle all status error 
  _errorHandler(err) {
    console.log(err);
    this.processing = false;
    return err;
  }

  //function for load and gettting data
    setPage(page: number) {
      if (page < 1) {
          return;
      }
      this.isDataAvailable = true;
      //api側でソートしてみたので一旦はずす
      
      this.questionsAll = this.pagerService.getSorting(this.questionsAll,this.sortingConsultant , this.Acs);
      
      // get pager object from service
      this.pagerProcess = this.pagerService.getPager(this.questionsAll.length, page, this.totalItems);
      //get current page of items
      this.questions.next(this.questionsAll.slice(this.pagerProcess.startIndex, this.pagerProcess.endIndex + 1)) ;
      this.pager.next(this.pagerProcess);
  
    }
}


// WEBPACK FOOTER //
// ./src/app/component/customer/student/studentdetail/studentdetail.service.ts